import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Layout } from './Dashboard';
import { API } from '../App';
import { toast } from 'sonner';
import { Plus, Trash2, Building2 } from 'lucide-react';

const Establishments = () => {
  const [establishments, setEstablishments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newEstablishment, setNewEstablishment] = useState({
    name: '',
    type: 'Hostel'
  });

  useEffect(() => {
    loadEstablishments();
  }, []);

  const loadEstablishments = async () => {
    try {
      const res = await axios.get(`${API}/establishments`);
      setEstablishments(res.data);
    } catch (error) {
      toast.error('Failed to load establishments');
    } finally {
      setLoading(false);
    }
  };

  const createEstablishment = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/establishments`, newEstablishment);
      toast.success('Establishment created!');
      setShowModal(false);
      setNewEstablishment({ name: '', type: 'Hostel' });
      loadEstablishments();
    } catch (error) {
      toast.error('Failed to create establishment');
    }
  };

  const deleteEstablishment = async (id) => {
    if (!window.confirm('Delete this establishment?')) return;
    try {
      await axios.delete(`${API}/establishments/${id}`);
      toast.success('Establishment deleted');
      loadEstablishments();
    } catch (error) {
      toast.error('Failed to delete establishment');
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="text-center py-12">Loading...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h2 className="text-3xl font-bold text-gray-900">Establishments</h2>
          <button
            onClick={() => setShowModal(true)}
            className="flex items-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            <Plus className="w-4 h-4" />
            <span>New Establishment</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {establishments.map((establishment) => (
            <div key={establishment.id} className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
              <div className="flex justify-between items-start mb-4">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <Building2 className="w-6 h-6 text-blue-600" />
                    <h3 className="text-xl font-semibold text-gray-900">{establishment.name}</h3>
                  </div>
                  <p className="text-sm text-gray-500">{establishment.type}</p>
                </div>
                <button
                  onClick={() => deleteEstablishment(establishment.id)}
                  className="text-red-600 hover:text-red-700"
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Create Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl shadow-xl p-6 max-w-md w-full">
              <h3 className="text-2xl font-bold mb-4">New Establishment</h3>
              <form onSubmit={createEstablishment} className="space-y-4">
                <input
                  type="text"
                  placeholder="Establishment Name"
                  required
                  value={newEstablishment.name}
                  onChange={(e) => setNewEstablishment({ ...newEstablishment, name: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                />
                <input
                  type="text"
                  placeholder="Type (e.g., Hostel, Hotel, Bungalow)"
                  required
                  value={newEstablishment.type}
                  onChange={(e) => setNewEstablishment({ ...newEstablishment, type: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                />
                <div className="flex space-x-3">
                  <button
                    type="submit"
                    className="flex-1 bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
                  >
                    Create
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="flex-1 bg-gray-600 text-white py-2 rounded hover:bg-gray-700"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Establishments;
